if ( typeof MainHeader !== 'function' ) {

	class MainHeader extends HTMLElement {

		constructor(){
			super();
			this.mount();
		}

		mount(){

			/* -- > DRAWERS < -- */

			// Sticky header

			if ( this.hasAttribute('data-sticky-header') ) {

				const stickyHeader = document.createElement('div');
				stickyHeader.classList = 'sticky-header'
				stickyHeader.setAttribute('data-js-inert', '');
				stickyHeader.innerHTML = `<div class="header__bottom header-container container--large portable-hide">
					${this.querySelector('.header__bottom').innerHTML}
				</div>
				<div class="site-header header__top container--large">
					${this.querySelector('.header__top').innerHTML}
				</div>`;
				document.body.append(stickyHeader);

				if ( this.querySelector('.button--cart-handle') && stickyHeader.querySelector('.header-actions') ) {
					stickyHeader.querySelector('.header-actions').append(this.querySelector('.button--cart-handle').cloneNode(true));
				}
				if ( this.querySelector('.site-search-handle') && stickyHeader.querySelector('.header-actions .button--cart-handle') ) {
					const stickySearchHandle = document.createElement('button');
					stickySearchHandle.type = 'button';
					stickySearchHandle.className = 'no-js-hidden button--sticky-search-handle';
					stickySearchHandle.setAttribute('data-js-sticky-search-toggle', '');
					stickySearchHandle.setAttribute('aria-label', 'Search');
					stickySearchHandle.innerHTML = `<span class="button__icon" role="img" aria-hidden="true">${this.querySelector('.site-search-handle .button__icon')?.innerHTML || ''}</span>`;
					stickyHeader.querySelector('.header-actions').insertBefore(stickySearchHandle, stickyHeader.querySelector('.header-actions .button--cart-handle'));
				}

				stickyHeader.querySelectorAll('[id]').forEach(elm=>{
					elm.id = `${elm.id}-sticky`;
				})
				stickyHeader.querySelectorAll('[aria-controls]').forEach(elm=>{
					if ( ! ( elm.hasAttribute('data-js-sidebar-handle') || elm.hasAttribute('data-modal') ) ) {
						elm.setAttribute('aria-controls', `${elm.getAttribute('aria-controls')}-sticky`);
					}
				})

				window.lst = window.scrollY;
				window.lhp = 0;

				const stickyHeaderDeskBound = this.querySelector('.header__bottom');
				const stickyHeaderMobileBound = this.querySelector('.header__top');

				this.SCROLL_StickyHelper = () =>{
					
					var st = window.scrollY;
					if ( ( st <= 0 || ( window.innerWidth >= 1024 ? stickyHeaderDeskBound.getBoundingClientRect().top >= 0 : stickyHeaderMobileBound.getBoundingClientRect().top >= 0 ) ) && stickyHeader.classList.contains('show') ) {
						stickyHeader.classList.remove('show');
						return;
					}

					if ( st < 0 || Math.abs(lst - st) <= 5 )
						return;	

					if ( st > window.lhp ) {

						if ( st == 0 && stickyHeader.classList.contains('show') ) {

							stickyHeader.classList.remove('show');

						} else if ( st <= lst && ! stickyHeader.classList.contains('show') ) {

							window.lhp = stickyHeader.offsetTop;
							if ( ( window.innerWidth >= 1024 ? stickyHeaderDeskBound.getBoundingClientRect().top : stickyHeaderMobileBound.getBoundingClientRect().top ) < -100 ) {
								stickyHeader.classList.add('show');
							}

						} else if ( st > lst && stickyHeader.classList.contains('show') ) {
							stickyHeader.classList.remove('show');
						}

					} 

					window.lst = st;

				}

				window.addEventListener('scroll', this.SCROLL_StickyHelper, {passive:true});

				stickyHeader.querySelectorAll('.submenu-masonry').forEach(elm=>{
					if ( Macy ) {
						const submenuMacy = new Macy({
							container: elm,
							columns: elm.classList.contains('with-promotion') ? 3 : 4
						});
						setTimeout(()=>{
							submenuMacy.reInit();
						}, 100);
					}
				});
				
			}

			// drawer cart connections

			document.querySelectorAll('[data-js-sidebar-handle]').forEach(elm => {
				if ( elm.hasAttribute('aria-controls') ) {
					const elmSidebar = document.getElementById(elm.getAttribute('aria-controls'));
					elm.addEventListener('click', e=>{
						e.preventDefault();
						elm.setAttribute('aria-expanded', 'true');
						elmSidebar.show();
					})
					elm.addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							elm.setAttribute('aria-expanded', 'true');
							elmSidebar.show();
							window.lastFocusedElm = elm;
							elmSidebar.querySelector('[data-js-close]').focus();
						}
					})
				}
			})

			// mobile search toggle
			document.querySelectorAll('[data-js-mobile-search-toggle]').forEach(mobileSearchToggle => {
				const mobileSearchContainer = document.querySelector('#mobile-search-container');
				const mobileSearchInput = document.querySelector('[data-js-mobile-search-input]');
				
				mobileSearchToggle.addEventListener('click', e => {
					e.preventDefault();
					const isExpanded = mobileSearchToggle.getAttribute('aria-expanded') === 'true';
					console.log('isExpanded', isExpanded);
					if ( false ) {
						// Hide search
						mobileSearchContainer.classList.add('mobile-search--hidden');
						mobileSearchToggle.setAttribute('aria-expanded', 'false');
					} else {
						// For iOS Safari: show element synchronously first (within user interaction context)
						mobileSearchContainer.classList.remove('mobile-search--hidden');
						mobileSearchToggle.setAttribute('aria-expanded', 'true');
						
						// Focus the input immediately to preserve user interaction context for iOS Safari
						if ( mobileSearchInput ) {
							// Ensure input is visible and focusable
							mobileSearchInput.style.display = '';
							mobileSearchInput.removeAttribute('readonly');
							mobileSearchInput.removeAttribute('disabled');
							
							// Force reflow to ensure element is rendered before focusing
							mobileSearchInput.offsetHeight;
							
							// Focus immediately (synchronously) to preserve user interaction context
							mobileSearchInput.focus();
							
							// iOS Safari sometimes needs a small delay and second focus attempt
							// Use the smallest possible delay (0ms) to stay within interaction context
							setTimeout(() => {
								if (document.activeElement !== mobileSearchInput) {
									mobileSearchInput.focus();
								}
							}, 0);
						}
						
						// Scroll to top after showing search (non-blocking)
						window.scrollTo({ top: 0, behavior: 'smooth' });
					}
				});
			});

			// sticky search toggle
			document.querySelectorAll('[data-js-sticky-search-toggle]').forEach(stickySearchToggle => {
				const desktopSearchInput = this.querySelector('.header__top [data-js-search-input][data-js-focus-overlay="search-results-overlay-desktop"]');

				stickySearchToggle.addEventListener('click', e => {
					e.preventDefault();
					window.scrollTo({ top: 0, behavior: 'smooth' });
					if ( desktopSearchInput ) {
						desktopSearchInput.style.display = '';
						desktopSearchInput.removeAttribute('readonly');
						desktopSearchInput.removeAttribute('disabled');
						desktopSearchInput.offsetHeight;
						setTimeout(() => {
							desktopSearchInput.focus({ preventScroll: true });
							if ( document.activeElement !== desktopSearchInput ) {
								desktopSearchInput.focus();
							}
						}, 350);
					}
				});
			});
			
			// closing drawers

			document.querySelectorAll('sidebar-drawer [data-js-close]').forEach(elm=>{
				elm.addEventListener('keydown', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( window.lastFocusedElm ) {
							setTimeout(()=>{
								window.lastFocusedElm.focus();
								window.lastFocusedElm = null;
							}, 100);
						}
					}
				});
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( e.target.closest('.sidebar').classList.contains('sidebar--opened') ) {
						e.target.closest('.sidebar').hide();
					}
				});
			});
			document.querySelector('.site-overlay').addEventListener('click', ()=>{
				if ( document.querySelector('.sidebar--opened') ) {
					document.querySelector('.sidebar--opened').hide();
				}
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.ESC ) {
					if ( document.querySelector('.sidebar--opened') ) {
						document.querySelector('.sidebar--opened').hide();
						if ( window.lastFocusedElm ) {
							window.lastFocusedElm.focus();
							window.lastFocusedElm = null;
						}
					}
				}
			});

			// resizing drawers

			const rootHeight = document.getElementById('root-height');
			this.RESIZE_SidebarHelper = debounce(()=>{
				rootHeight.innerHTML = `:root {
					--window-height: ${window.innerHeight}px;
				}`;
			}, 200);
			window.addEventListener('resize', this.RESIZE_SidebarHelper);
			rootHeight.innerHTML = `:root {
				--window-height: ${window.innerHeight}px;
			}`;

			// Inert elements

			document.querySelectorAll('#main > div').forEach(elm=>{
				if ( ! elm.classList.contains('inert-inside') ) {
					elm.setAttribute('data-js-inert', '');
				}
			})
			window.inertElems = document.querySelectorAll('[data-js-inert]');

			// Init modal windows

			document.querySelectorAll('[aria-controls="modal-store-selector"]').forEach(elm=>{
				elm.addEventListener('keydown', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						window.lastFocusedElm = elm;
					}
				})
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( document.querySelector('.sidebar--opened') ) {
						document.querySelector('.sidebar--opened').hide();
					}
					if ( document.getElementById(elm.getAttribute('aria-controls')) ) {
						document.getElementById(elm.getAttribute('aria-controls')).show();
					}
				})
				elm.addEventListener('keyup', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( document.querySelector('.sidebar--opened') ) {
							document.querySelector('.sidebar--opened').hide();
						}
						if ( document.getElementById(elm.getAttribute('aria-controls')) ) {
							document.getElementById(elm.getAttribute('aria-controls')).show();
						}
					}
				})
			});

			// Submenu alignment

			const rtl = document.documentElement.getAttribute('dir') == 'rtl';
			document.querySelectorAll('.site-nav.style--classic .has-submenu').forEach(elm=>{
				elm.addEventListener('mouseover', ()=>{
					if ( elm.querySelector('.normal-menu') ) {
						elm.querySelector('.normal-menu').style.left = `${rtl ? elm.getBoundingClientRect().right : elm.getBoundingClientRect().left}px`;
					}
				})
			});

			// predictive search

			if ( JSON.parse(document.getElementById('shopify-features').text).predictiveSearch ) {
				document.querySelectorAll('search-form [data-js-search-input]').forEach(elm=>{
					elm.addEventListener('focus', ()=>{
						document.getElementById(elm.dataset.jsFocusOverlay).classList.add('active');
						if ( ! document.body.classList.contains('predictive-script-loaded') ) {
							document.body.classList.add('predictive-script-loaded')
							const predictiveSearchJS = document.createElement('script');
							predictiveSearchJS.src = KROWN.settings.predictive_search_script;
							document.head.appendChild(predictiveSearchJS); 
						}
					})
					elm.addEventListener('keydown', e=>{
						if ( e.keyCode == window.KEYCODES.TAB ) {
							if ( document.getElementById('search-results-overlay-desktop').classList.contains('active') ) {
								document.getElementById('search-results-overlay-desktop').classList.remove('active');
							}
						}
					})
				})
				window.addEventListener('load', ()=>{
					document.querySelectorAll('.search-results-overlay').forEach(elm=>{
						elm.style = '';
					})
				});
			} else {
				document.querySelector('search-form [data-js-search-input] + button').classList.add('button--invisibile-trigger');
			}

			// touch navigation for the menu

			const closeTouchSubmenus = (focusedElm, focusedParent=null)=>{
				document.querySelectorAll('.style--classic li.focus').forEach(elm=>{
					if ( ! ( elm === focusedElm || elm === focusedParent ) ) {
						elm.classList.remove('focus');
					}
				})
			}
			const restoreMenuLinkPointer = link => {
				if ( link ) {
					link.style.pointerEvents = '';
				}
			};
			let babyMenuTouch = false;
			document.querySelectorAll('.style--classic .has-babymenu').forEach(elm=>{
				const menuLink = elm.firstElementChild;
				elm.addEventListener('touchstart', ()=>{
					menuLink.style.pointerEvents = 'none';
					elm.classList.toggle('focus');
					babyMenuTouch = true;
					closeTouchSubmenus(elm,elm.closest('.has-submenu'));
				}, { passive:true });
				elm.addEventListener('touchend', ()=>restoreMenuLinkPointer(menuLink), { passive:true });
				elm.addEventListener('touchcancel', ()=>restoreMenuLinkPointer(menuLink), { passive:true });
			})
			document.querySelectorAll('.style--classic .has-submenu').forEach(elm=>{
				if ( ! elm.classList.contains('mega-link') ) {
					const menuLink = elm.firstElementChild;
					elm.addEventListener('touchstart', ()=>{
						menuLink.style.pointerEvents = 'none';
						if ( ! babyMenuTouch ) {
							elm.classList.toggle('focus');
							closeTouchSubmenus(elm);
						}
						babyMenuTouch = false;
					}, { passive:true });
					elm.addEventListener('touchend', ()=>restoreMenuLinkPointer(menuLink), { passive:true });
					elm.addEventListener('touchcancel', ()=>restoreMenuLinkPointer(menuLink), { passive:true });
				}
			})

			// tab navigation for the menu

			const topLevelMenuLinks = Array.from(document.querySelectorAll('.site-nav.style--classic .has-submenu > a'));
			const menuFocusableSelector = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
			const openMenuItem = (menuItem, trigger)=>{
				if ( ! menuItem || ! trigger ) return;
				menuItem.classList.add('focus');
				trigger.setAttribute('aria-expanded', 'true');
			};
			const closeMenuItem = (menuItem, trigger)=>{
				if ( ! menuItem || ! trigger ) return;
				menuItem.classList.remove('focus');
				trigger.setAttribute('aria-expanded', 'false');
			};
			const focusFirstSubmenuItem = menuItem => {
				if ( ! menuItem ) return;
				const firstItem = menuItem.querySelector(`.submenu ${menuFocusableSelector}`);
				if ( firstItem ) {
					firstItem.focus();
				}
			};

			document.querySelectorAll('.site-nav.style--classic .has-submenu > a').forEach(childEl=>{

				const elm = childEl.parentNode;

				elm.addEventListener('keydown', e=>{
					const currentTopLevelIndex = topLevelMenuLinks.indexOf(childEl);
					const isEnter = e.keyCode == window.KEYCODES.RETURN || e.key === 'Enter';
					const isSpace = e.key === ' ' || e.key === 'Spacebar' || e.code === 'Space' || e.keyCode === 32;
					const isEscape = e.keyCode == window.KEYCODES.ESC || e.key === 'Escape' || e.key === 'Esc';
					const isArrowDown = e.key === 'ArrowDown' || e.keyCode === 40;
					const isArrowRight = e.key === 'ArrowRight' || e.keyCode === 39;
					const isArrowLeft = e.key === 'ArrowLeft' || e.keyCode === 37;
					const isTriggerEvent = e.target === childEl;
					if ( isEnter || isSpace ) {
						if ( ! isTriggerEvent ) {
							return;
						}
						if ( ! childEl.classList.contains('no-focus-link') ) {
							e.preventDefault();
						}
						if ( ! elm.classList.contains('focus') ) {
							openMenuItem(elm, childEl);
						} else if ( document.activeElement.parentNode.classList.contains('has-submenu') ) {
							closeMenuItem(elm, childEl);
						}
					} else if ( isEscape ) {
						e.preventDefault();
						closeMenuItem(elm, childEl);
						childEl.focus();
					} else if ( isArrowDown ) {
						if ( ! isTriggerEvent ) {
							return;
						}
						e.preventDefault();
						openMenuItem(elm, childEl);
						focusFirstSubmenuItem(elm);
					} else if ( isArrowRight && currentTopLevelIndex > -1 ) {
						if ( ! isTriggerEvent ) {
							return;
						}
						e.preventDefault();
						const nextLink = topLevelMenuLinks[currentTopLevelIndex + 1];
						if ( nextLink ) {
							nextLink.focus();
						}
					} else if ( isArrowLeft && currentTopLevelIndex > -1 ) {
						if ( ! isTriggerEvent ) {
							return;
						}
						e.preventDefault();
						const previousLink = topLevelMenuLinks[currentTopLevelIndex - 1];
						if ( previousLink ) {
							previousLink.focus();
						}
					}
				});	
				
				if ( elm.querySelector('.submenu-holder > li:last-child a') ) {
					elm.querySelector('.submenu-holder > li:last-child a').addEventListener('focusout', e=>{
						if ( elm.classList.contains('focus') ) {
							closeMenuItem(elm, childEl);
							//elmMenu.setAttribute('aria-hidden', 'true');
						}
					});
				}

			});

			document.querySelectorAll('.site-nav.style--classic .has-babymenu:not(.mega-link) > a.menu-link, .site-nav.style--classic .has-babymenu:not(.mega-link) > .menu-link-row > a.menu-link').forEach(childEl=>{	

				const elm = childEl.closest('.has-babymenu');

				elm.addEventListener('keydown', e=>{
					const isEnter = e.keyCode == window.KEYCODES.RETURN || e.key === 'Enter';
					const isSpace = e.key === ' ' || e.key === 'Spacebar' || e.code === 'Space' || e.keyCode === 32;
					const isEscape = e.keyCode == window.KEYCODES.ESC || e.key === 'Escape' || e.key === 'Esc';
					const isArrowDown = e.key === 'ArrowDown' || e.keyCode === 40;
					const isTriggerEvent = e.target === childEl;
					if ( isEnter || isSpace ) {
						if ( ! isTriggerEvent ) {
							return;
						}
						if ( ! childEl.classList.contains('no-focus-link') ) {
							e.preventDefault();
						}
						if ( ! elm.classList.contains('focus') ) {
							elm.classList.add('focus');
							e.target.setAttribute('aria-expanded', 'true');
							//elmMenu.setAttribute('aria-hidden', 'false');
						} else {
							elm.classList.remove('focus');
							e.target.setAttribute('aria-expanded', 'false');
							//elmMenu.setAttribute('aria-hidden', 'true');
						}
					} else if ( isEscape ) {
						e.preventDefault();
						elm.classList.remove('focus');
						childEl.setAttribute('aria-expanded', 'false');
						childEl.focus();
					} else if ( isArrowDown ) {
						if ( ! isTriggerEvent ) {
							return;
						}
						e.preventDefault();
						if ( ! elm.classList.contains('focus') ) {
							elm.classList.add('focus');
							e.target.setAttribute('aria-expanded', 'true');
						}
						const firstBabyLink = elm.querySelector(`.babymenu ${menuFocusableSelector}`);
						if ( firstBabyLink ) {
							firstBabyLink.focus();
						}
					}
				});

				if ( elm.querySelector('.babymenu li:last-child a') ) {
					elm.querySelector('.babymenu li:last-child a').addEventListener('focusout', e=>{
						if ( elm.classList.contains('focus') ) {
							elm.classList.remove('focus');
							childEl.setAttribute('aria-expanded', 'false');
						}
					});
				}

			})

		}

		unmount(){
			window.removeEventListener('resize', this.RESIZE_SidebarHelper);
		}

	}
	
  if ( typeof customElements.get('main-header') == 'undefined' ) {
		customElements.define('main-header', MainHeader);
	}

}

if ( typeof SidebarDrawer !== 'function' ) {

	class SidebarDrawer extends HTMLElement {

		constructor(){
			super();
			this.querySelector('[data-js-close]').addEventListener('click', ()=>{
				this.hide();
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.ESC ) {
					const openedSidebar = document.querySelector('sidebar-drawer.sidebar--opened');
					if ( openedSidebar ){
						openedSidebar.hide();
					}
				}
			});
		}

		/* 
			* generic hide/show functions 
		*/

		show(){

			// When opening the main cart drawer, always close the cart popup (if present)
			if ( this.id == "site-cart-sidebar" ) {
				const cartPopup = document.getElementById('site-cart-popup');
				if ( cartPopup && typeof cartPopup.hide === 'function' ) {
					cartPopup.hide();
				}
			}

			this.opened = true;
			this.removeAttribute('aria-hidden');
			document.body.classList.add('sidebar-opened');
			if ( this.classList.contains('sidebar--right') ) {
				document.body.classList.add('sidebar-opened--right');
			} else if ( this.classList.contains('sidebar--left') ) {
				document.body.classList.add('sidebar-opened--left');
			}
			if ( this.id == "site-cart-popup" ) {
				this.style.display = 'flex';
			} else {
			this.style.display = 'grid';
			}
			setTimeout(()=>{
				this.classList.add('sidebar--opened');
				window.inertElems.forEach(elm=>{
					elm.setAttribute('inert', '');
				})
				// Dispatch cart-opened event when cart sidebar is fully opened
				if ( this.id == "site-cart-sidebar" ) {
					const event = new CustomEvent('cart-opened', { bubbles: true });
					document.dispatchEvent(event);
				}
				if ( this.id == "site-cart-popup" ) {
					// Fired when the cart popup drawer becomes fully opened.
					const event = new CustomEvent('cart-popup-opened', { bubbles: true });
					document.dispatchEvent(event);
				}
			}, 15);
			if ( this.id == "site-cart-sidebar" ) {
				if ( document.querySelector('#cart-recommendations css-slider') ) {
					document.querySelector('#cart-recommendations css-slider').resetSlider();
				}
			}

		}

		hide(){

			this.opened = false;
			this.classList.remove('sidebar--opened');

			document.body.classList.remove('sidebar-opened');
			document.body.classList.remove('sidebar-opened--left');
			document.body.classList.remove('sidebar-opened--right');
			window.inertElems.forEach(elm=>{
				elm.removeAttribute('inert');
			})

			document.querySelector(`[aria-controls="${this.id}"]`)?.setAttribute('aria-expanded', 'false');

			setTimeout(()=>{
				this.style.display = 'none';
			}, 501);

		}

	}


  if ( typeof customElements.get('sidebar-drawer') == 'undefined' ) {
		customElements.define('sidebar-drawer', SidebarDrawer);
	}

}

if ( typeof MobileNavigation !== 'function' ) {
		
	class MobileNavigation extends HTMLElement {

		constructor() {

			super();

			this._openedFirstSubmenu = false;
			this._openedSecondSubmenu = false;

			this.querySelectorAll('.has-submenu > a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( ! this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = true;
						this.classList.add('opened-first-submenu');
						this.closest('sidebar-drawer').scrollTo({top: 0});
					}
					e.target.closest('li').classList.add('opened');
					this._resizeContainer();
				})
			});

			this.querySelectorAll('.has-babymenu > a.menu-link, .has-babymenu > .menu-link-row > a.menu-link').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( ! this._openedSecondSubmenu ) {
						this._openedSecondSubmenu = true;
						this.classList.add('opened-second-submenu');
						this.closest('sidebar-drawer').scrollTo({top: 0});
					}
					e.target.closest('li').classList.add('opened');
					this._resizeContainer();
				})
			});

			this.querySelectorAll('.submenu-back a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					if ( this._openedSecondSubmenu ) {
						this._openedSecondSubmenu = false;
						this.classList.remove('opened-second-submenu');
						this._resizeContainer();
					} else if ( this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = false;
						this.classList.remove('opened-first-submenu');
						this._resizeContainer(true);
					}
					this.closest('sidebar-drawer').scrollTo({top: 0});
					setTimeout(()=>{
						e.target.closest('li.opened').classList.remove('opened');
					}, 301);
					e.preventDefault();
				})
			});

			if ( this.dataset.showHeaderActions == 'true' ) {

				const mobileNavActions = document.createElement('div');
				mobileNavActions.classList = "header-actions flex-buttons";
				mobileNavActions.innerHTML = document.querySelector('[data-js-header-actions]').innerHTML;
				this.querySelector('nav').prepend(mobileNavActions);

				mobileNavActions.querySelectorAll('[id]').forEach(elm=>{
					elm.id = `${elm.id}-mobile`;
				});
				mobileNavActions.querySelectorAll('[data-modal]').forEach(elm=>{
					elm.addEventListener('keydown', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							window.lastFocusedElm = elm;
						}
					})
					elm.addEventListener('click', e=>{
						e.preventDefault();
						if ( document.querySelector('.sidebar--opened') ) {
							document.querySelector('.sidebar--opened').hide();
						}
						if ( document.getElementById(elm.getAttribute('aria-controls')) ) {
							document.getElementById(elm.getAttribute('aria-controls')).show();
						}
					})
				});
				
			}

		}

		_resizeContainer(main=false){
      if ( main ) {
				this.style.height = `auto`;
      } else {
				if ( this._openedSecondSubmenu ) {
					this.style.height = `${this.querySelector('.has-babymenu.opened .babymenu').scrollHeight}px`;
				} else if ( this._openedFirstSubmenu ) {
					this.style.height = `${this.querySelector('.has-submenu.opened .submenu').scrollHeight}px`;
				}  
      }
		}

	}

  if ( typeof customElements.get('mobile-navigation') == 'undefined' ) {
		customElements.define('mobile-navigation', MobileNavigation);
	}

}

if ( typeof ScrollableNavigation !== 'function' ) {

	class ScrollableNavigation extends HTMLElement {

		constructor() {

			super();

			this.linkList = this.querySelector('.link-list');
			this.header = this.parentNode;
			window.addEventListener('resize', debounce(()=>{
				this.checkNav();
			}, 200));
			this.checkNav();

			const rtl = document.documentElement.getAttribute('dir') == 'rtl';

			this.parentNode.querySelector('.scrollable-navigation-button--left').addEventListener('click', ()=>{
				this.scroll({
					top: 0,
					left: this.scrollLeft - (rtl ? -100 : 100),
					behavior: 'smooth'
				});
			})
			this.parentNode.querySelector('.scrollable-navigation-button--right').addEventListener('click', ()=>{
				this.scroll({
					top: 0,
					left: this.scrollLeft + (rtl ? -100 : 100),
					behavior: 'smooth'
				});
			})

		}

		checkNav() {
			if ( this.linkList.scrollWidth > this.offsetWidth ) {
				this.header.classList.add('scrolling-navigation-enabled');
			} else {
				this.header.classList.remove('scrolling-navigation-enabled');
			}
		}
		
	}

  if ( typeof customElements.get('scrollable-navigation') == 'undefined' ) {
		customElements.define('scrollable-navigation', ScrollableNavigation);
	}

}